<template>
    <div class="submenu">

        <!-- Menu Mobile -->
        <mu-menu cover placement="left-start" class="menu-mobile">
            <mu-button icon>
                <font-awesome-icon icon="ellipsis-v" class="icon-md"/>
            </mu-button>
            <mu-list slot="content" class="mu-list-custom">
                <mu-list-item button v-for="(item, key) in submenu" :to="{ name: item.route }" :color="item.color" :textColor="item.textColor" :key="key">
                    <mu-list-item-title>{{ item.name }}</mu-list-item-title>
                    <mu-list-item-action><font-awesome-icon :icon="item.icon" class="icon-md icon-margin-left"/>  </mu-list-item-action>
                </mu-list-item>
            </mu-list>
        </mu-menu>

        <!-- Menu Desktop -->
        <div class="menu-desktop">
            <mu-button v-for="(item, key) in submenu" @click="goTo(item)" round :color="item.color" :textColor="item.textColor" :key="key">
                <font-awesome-icon :icon="item.icon" class="icon-md icon-margin-left"/>
                {{ item.name }}
            </mu-button>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'submenu',

        // ╔═╗╦═╗╔═╗╔═╗╔═╗
        // ╠═╝╠╦╝║ ║╠═╝╚═╗
        // ╩  ╩╚═╚═╝╩  ╚═╝

        props: ['submenu'],

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            /**
             * Método para redirecionar a rota do item
             */
            goTo (item) {
                this.$router.push({ name: item.route }).catch(err => { if (err) console.log(err.name || '') })
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../assets/stylus/bootstrap.styl'

    .submenu
        float right

        .menu-desktop
            display none

        .mu-button
            margin-left 5px

    /* Tablet >= 768 pixels */
    @media (min-width: 768px)

        .submenu

            .menu-desktop
                display block

</style>
